import { combineReducers } from '@reduxjs/toolkit';

import { default as ErrorReducer } from '../slices/error';
import { default as UserReducer } from '../slices/user';

const rootReducer = combineReducers({
    error: ErrorReducer,
    user: UserReducer,
})

export default rootReducer;
